
const MIN_RANDOM_CHAR_NUMBER = 35
const MAX_RANDOM_CHAR_NUMBER = 126

/**
 * Gets a random char
 */
export function GetRandomChar () {
  let num = Math.random() * (MAX_RANDOM_CHAR_NUMBER - MIN_RANDOM_CHAR_NUMBER) + MIN_RANDOM_CHAR_NUMBER
  return String.fromCharCode(num)
}

/**
 * Replaces a char in a string(text) at index i
 */
export function ReplaceChar(text, i, char) {
    return text.substr(0,i) + char + text.substr(i+1,)
}